<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="委外入库单"
      :page="page"
      :show-query="true"
      :get-data-func="api.list"
      @row-select="rowSelect"
      urlHash="business/stock/outsourcingshipmentwarehousing"
      :temp-params="tempParams"
      :queryParamsAppend="queryParamsAppend"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>

    <el-table
      border
      class="table_bottom table-line tb-c-head"
      :data="tableData"
      style="margin-top: 18px"
    >
      <el-table-column
        prop="SourceNo"
        label="加工单号"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="ProductNo"
        label="存货编码"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="ProductName"
        label="存货名称"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="ProductSpec"
        label="规格"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="ColorName"
        label="颜色"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="PropertyName"
        label="属性"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="UnitName"
        label="计量单位"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="Quantity"
        label="数量"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="Price"
        label="单价"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="Amount"
        label="金额"
        min-width="100"
        align="center"
      ></el-table-column>
    </el-table>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";

export default {
  mixins: [listMixin],
  components: { list },
  provide() {
    return {
      IsDefaultMonth: false,
    };
  },
  data() {
    return {
      WarehouseList: [],
      warehouseApi: require("@/api/ba/warehouse").default,
      api: require("@/api/stock/stDirectInDoc").default,
      sourceTypeApi: require("@/api/ba/sourceType").default,
      trendShow: true,
      queryParamsAppend: {},
      tableData: [],
      tempParams: {
        InType: 2,
      },
    };
  },
  activated() {
    let SET_PurchaseReceipt = null;
    if (localStorage.getItem("SET_PurchaseReceipt") === "true") {
      SET_PurchaseReceipt = true;
    } else {
      SET_PurchaseReceipt = false;
    }
    let WarehouseTypes = [];
    if (SET_PurchaseReceipt) {
      WarehouseTypes = [1, 3];
    } else {
      WarehouseTypes = [1];
    }
    this.warehouseApi
      .list({ Status: 1, WarehouseTypes: WarehouseTypes })
      .then((res) => {
        if (res.Code === 0) {
          this.WarehouseList = res.Data;
        }
      });
  },
  //  created() {
  //     this.sourceTypeApi.info("委外直运入库单").then(res=> {
  //         this.tempParams.InType=res.SourceTypeId
  //     });
  // },
  methods: {
    rowSelect(row) {
      let id = row.DocId;
      this.api.info(id).then((res) => {
        if (res.Code === 0) {
          this.tableData = res.Data.Products;
        }
      });
    },
  },
};
</script>
